const AFFILIATE_REF_KEY = 'affiliate_ref';
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

interface StoredRef {
  code: string;
  ts: number;
}

function isStoredRef(value: unknown): value is StoredRef {
  return (
    typeof value === 'object' &&
    value !== null &&
    'code' in value &&
    typeof value.code === 'string' &&
    'ts' in value &&
    typeof value.ts === 'number'
  );
}

export function saveAffiliateRef(code: string): void {
  const data: StoredRef = { code, ts: Date.now() };
  localStorage.setItem(AFFILIATE_REF_KEY, JSON.stringify(data));
}

export function getAffiliateRef(): string | undefined {
  const raw = localStorage.getItem(AFFILIATE_REF_KEY);
  if (!raw) return undefined;

  try {
    const data: unknown = JSON.parse(raw);
    if (!isStoredRef(data)) {
      localStorage.removeItem(AFFILIATE_REF_KEY);
      return undefined;
    }
    if (Date.now() - data.ts > MAX_AGE_MS) {
      localStorage.removeItem(AFFILIATE_REF_KEY);
      return undefined;
    }
    return data.code;
  } catch {
    localStorage.removeItem(AFFILIATE_REF_KEY);
    return undefined;
  }
}

export function clearAffiliateRef(): void {
  localStorage.removeItem(AFFILIATE_REF_KEY);
}
